/* eslint-disable no-unused-vars */

import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import {
	MuiPickersUtilsProvider,
	KeyboardDatePicker,
} from '@material-ui/pickers';
import { format, addDays } from 'date-fns';
import './Calendar.scss';
import es from 'date-fns/locale/es';

// interface Props {
//   disableTwoDays?: boolean;
//   disableDate?: number[];
//   disabledWeekends?: boolean;
//   disableFuture?: boolean;
//   disablePast?: boolean;
//   disableSunday?: boolean;
//   name: string;
//   className?: string;
//   label?: string;
//   value: Date | string | null;
//   onChange: (date: Date | string | null) => void;
// }

function CalendarWeb({
	label,
	onChange,
	disableTwoDays,
	value,
	disableDate,
	disabledWeekends,
	disableFuture,
	disablePast,
	disableSunday,
	...otherProps
}: any) {
	const configDate = {
		...otherProps,
		name: 'date',
		disableToolbar: true,
		format: 'MM/dd/yyyy',
		id: 'date-picker-inline',
		margin: 'normal',
		variant: 'inline',
		KeyboardButtonProps: {
			'aria-label': 'change date',
		},
		fullWidth: true,
	};

	const disableDays = (date: any) => {
		const day = date.getDate();
		const weekends = date.getDay() === 0 || date.getDay() === 6;
		const sunday = date.getDay() === 0;

		if (disableTwoDays) {
			const a = new Date();
			const d1 = addDays(a, 1);
			const d2 = addDays(a, 2);

			const dat = format(date, 'MM/dd/yyyy');
			const d1f = format(d1, 'MM/dd/yyyy');
			const d2f = format(d2, 'MM/dd/yyyy');

			return dat === d1f || dat === d2f || sunday;
		}

		if (disableSunday) return sunday;

		if (!disableDate) {
			return weekends;
		}

		if (!disabledWeekends) {
			return disableDate.includes(day);
		}

		return weekends || disableDate.includes(day);
	};

	return (
		<MuiPickersUtilsProvider locale={es} utils={DateFnsUtils}>
			<KeyboardDatePicker
				{...configDate}
				disableFuture={disableFuture}
				disablePast={disablePast}
				label={label}
				onChange={onChange}
				shouldDisableDate={(disabledWeekends || disableDate) && disableDays}
				// value={value ? value : format(addDays(new Date(), 3), 'MM/dd/yyyy')}
				value={value || format(new Date(), 'MM/dd/yyyy')}
			/>
		</MuiPickersUtilsProvider>
	);
}

export default CalendarWeb;
